"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClickableAreaStyled = exports.BigButtonStyled = exports.BigButtonText = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _hotspot = require("../../hotspot.constants");

var _hotspotGlobal = require("../../hotspot.global.styles");

var _hotspot2 = _interopRequireDefault(require("../../hotspot.styles"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var animateIn = (0, _styledComponents.keyframes)(["0%{max-width:0;max-height:0;opacity:0;transform:translate(-50%,-50%) scaleX(0);}50%{max-width:4em;max-height:2.5em;transform:translate(-50%,-50%) scaleX(0.5);}100%{height:2.5em;opacity:1;max-width:6em;max-height:2.5em;transform:translate(-50%,-50%) scaleX(1);}"]);
var animateText = (0, _styledComponents.keyframes)(["0%{transform:translateY(4em)}50%{transform:translateY(4em)}100%{transform:translateY(0)}"]);

var BigButtonText = _styledComponents.default.div.withConfig({
  displayName: "BigButtonstyles__BigButtonText",
  componentId: "cxo5ph-0"
})(["animation-duration:800ms;animation-name:", ";animation-timing-function:cubic-bezier(0.16,1,0.7,1);font-family:Poppins,sans-serif;text-align:center;transition:color 300ms,font-size 300ms,padding 300ms,letter-spacing 300ms;white-space:nowrap;"], animateText); // $FlowFixMe


exports.BigButtonText = BigButtonText;

var BigButtonStyled = _styledComponents.default.div.attrs(function (_ref) {
  var iconPosition = _ref.iconPosition;
  return {
    style: {
      left: "".concat(iconPosition.left, "%"),
      top: "".concat(iconPosition.top, "%")
    }
  };
}).withConfig({
  displayName: "BigButtonstyles__BigButtonStyled",
  componentId: "cxo5ph-1"
})(["display:flex;flex-direction:column;justify-content:center;background:", ";color:", ";font-size:2em;font-weight:bold;letter-spacing:0.05em;text-align:center;border-radius:3em;height:2.5em;padding:0 1.5em;max-height:6em;top:50%;left:50%;overflow:hidden;position:absolute;transform:", ";transition:opacity 150ms,background-color 300ms,height 300ms,padding 300ms,max-width 300ms,transform 300ms ease 200ms;transform-origin:center;animation:", " 300ms ease;"], function (_ref2) {
  var config = _ref2.config;
  return config.backgroundColor;
}, function (_ref3) {
  var config = _ref3.config;
  return config.color;
}, _hotspotGlobal.translateXY, animateIn);

exports.BigButtonStyled = BigButtonStyled;

var hoverState = function hoverState(hoverStyle) {
  return "\n  ".concat(BigButtonStyled, " {\n    background: ").concat(hoverStyle.backgroundColor, ";\n    color: ").concat(hoverStyle.color, ";\n    height: 2em;\n    max-height: 5em;\n    padding: 0 1em;\n    letter-spacing: 0.1em;\n  }\n\n  ").concat(BigButtonText, " {\n    \n    line-height: 1em;\n  }\n");
};

var ClickableAreaStyled = (0, _styledComponents.default)(_hotspot2.default).withConfig({
  displayName: "BigButtonstyles__ClickableAreaStyled",
  componentId: "cxo5ph-2"
})(["", ""], function (_ref4) {
  var disableHover = _ref4.disableHover;
  return !disableHover && (0, _styledComponents.css)(["&:hover,&", "{", ";}", ""], _hotspot.focusVisible, function (_ref5) {
    var hoverStyle = _ref5.hoverStyle;
    return hoverState(hoverStyle);
  }, function (_ref6) {
    var hoverStyle = _ref6.hoverStyle,
        previewHoverState = _ref6.previewHoverState;
    return previewHoverState && hoverState(hoverStyle);
  });
});
exports.ClickableAreaStyled = ClickableAreaStyled;